// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"3959fb91","887":"8033a697"}[chunkId] + ".chunk.js";
};